// 组件
import waterfallComponents from "@/components/contents/waterfallComponents.vue"; //瀑布流
import { getBabyMonth, advertisJump } from "@/assets/js/common";
// 方法
import {
  fomatterNum,
  formatDate,
  getCookie,
  goToMini,
  TestUserAgent,
  jump,
  resourceNiche,
} from "@/assets/js/common.js";
import {
  BuiedPointClick_Fn,
  Exposurer_babyFeed_pbuliu_Fn,
  Exposurer_babyList_Fn,
  Exposurer_informationlist_Fn,
  xmhziyuanwei_data_expo,
} from "@/assets/js/BuriedPointEvent.js";
import openWxTag from "@/components/common/openWeappTag/index.vue"; // 打开小程序开放标签

export default {
  name: "informationList",
  data() {
    return {
      dataList: [],
      pageWikipediaParams: {
        page: 1,
        newPage: 0,
        size: 24,
        error: false,
        loading: false,
        bottomText: "",
        finished: false,
      }, // 分页配置参数
      isSystem: "",
      userInfo: JSON.parse(localStorage.getItem("userInfo")), //用户数据
      requestId: "",
      monthage: "",
      isCustomized: false,
    };
  },
  props: ["loginFlag", "tagId"],
  components: {
    waterfallComponents,
    openWxTag,
  },
  // watch: {
  //   isEditFlag: {
  //     handler(newValue) {
  //       this.isCustomized = newValue ? 1 : 0;
  //       console.log(this.isCustomized, "isEditFlagisEditFlag");
  //     },
  //     immediate: true,
  //   },
  // },
  created() {
    if (this.userInfo && this.userInfo.crm_id) {
      this.getMonthsPeriod();
    }
  },
  computed: {
    // 星妈课堂  根据开始时间与结束时间来计算当前数据是否在直播中
    compareTime(startTime, endTime) {
      let nowDate = new Date().getTime();
      let beginDate = new Date(
        new Date(Date.parse(startTime.replace(/-/g, "/")))
      ).getTime();
      let endDate = new Date(
        new Date(Date.parse(endTime.replace(/-/g, "/")))
      ).getTime();
      return nowDate > beginDate && endDate > nowDate;
    },
  },
  mounted() {
    this.isSystem = TestUserAgent().isios;
    sessionStorage.removeItem("isDoctorDetail"); //每次进入页面清除
    this.getArticleList();
    // console.log(getBabyMonth(), "getBabyMonth");
  },
  methods: {
    jump,
    getBabyMonth,
    resourceNiche,
    ResourceBurial(item, index) {
      sensors.track("xmh5_ziyuanwei_click", {
        ...this.resourceNiche(item),
        xmh5_ziyuanwei_position: index + 1,
      });
    },
    getMonthsPeriod() {
      this.$http.get("/babyWikiRevision/monthsPeriod", {}, (res) => {
        if (res.code === "200") {
          this.optionList = [];
          for (var i = 0; i < res.data.length; i++) {
            if (res.data[i].id > 0 && res.data[i].id < 7) {
              this.optionList.push(res.data[i]);
            }
          }
          let babyNum = localStorage.getItem("babyNums");
          const babyInfo = JSON.parse(localStorage.getItem("babyInfo"));
          let id;
          if (babyNum) {
            id =
              babyInfo && babyInfo.length
                ? babyInfo.filter((item) => item.num == babyNum)[0]?.tag_id
                : null;
          } else {
            id =
              babyInfo && babyInfo.length
                ? babyInfo.filter(
                    (item) => item?.birth == this.info.first_baby_birthday
                  )[0]?.tag_id
                : null;
          }
          if (id == 1) {
            id = 2;
          } else if (id == 2) {
            id = 1;
          }
          const data = this.optionList.filter((item) => item.id == id);
          if (data.length) this.monthage = data[0].name;
          console.log(this.monthage, "optionList121212121");
          // console.log(this.getBabyMonth(), "optionList");
        }
      });
    },
    BuiedPointClick_Fn,
    fomatterNum,
    formatDate,
    goToMini,
    // 商品点击新增埋点
    moduleType11sensors(data, index) {
      BuiedPointClick_Fn(
        "xmhh5_home_feeds_click",
        this.getBuiedPointObj(data, index)
      );
      BuiedPointClick_Fn("xmhh5_home_feed_goodsclick", {
        xmhh5_home_feeds_googsname: data.title,
      });
    },
    /**
     * startDate  开始时间
     * endDate 结束时间
     * @returns
     * 1 未开始
     * 2 直播中
     * 3 已结束
     */
    compareDate(startDate, endDate) {
      if (startDate && endDate) {
        const curDate = new Date().getTime();
        const beginDate = new Date(
          new Date(Date.parse(startDate.replace(/-/g, "/")))
        ).getTime();
        const newEndDate = new Date(
          new Date(Date.parse(endDate.replace(/-/g, "/")))
        ).getTime();
        console.log(newEndDate == new Date("2020-01-01 00:00:00").getTime());
        // 判断结束时间是否为'2020-01-01 00:00:00'，为了兼容老数据没有结束时间的问题
        if (endDate == new Date("2020-01-01 00:00:00").getTime()) {
          return 3;
        } else {
          if (curDate > beginDate && curDate < newEndDate) {
            return 2;
          } else if (curDate < beginDate) {
            return 1;
          } else if (curDate > newEndDate) {
            return 3;
          }
        }
      }
    },
    // 获取文章列表
    getArticleList(changeBaby) {
      // if (localStorage.getItem('currentPage')) {
      //   this.pageWikipediaParams.newPage =
      //     JSON.parse(localStorage.getItem('currentPage')) + 1
      // } else {
      //   this.pageWikipediaParams.newPage = 1
      // }
      // 首页切换宝宝之后，changeBaby = true，则重置数据
      if (changeBaby) {
        this.pageWikipediaParams.newPage = 0;
        this.pageWikipediaParams.page = 1;
        this.dataList = [];
        this.$refs.waterfall.resetDefaultData();
      }
      let babyNums = localStorage.getItem("babyNums");
      let babyInfo = JSON.parse(localStorage.getItem("babyInfo"));
      let tagId =
        babyInfo && babyInfo[babyNums - 1] && babyInfo[babyNums - 1].tag_id; // 当前宝宝的月龄id
      let babyBirthDay = (babyInfo && babyInfo[babyNums - 1]?.birth) || ""; // 当前宝宝生日
      let date = Date.parse(new Date());
      let id = getCookie("xmh_unionid");
      this.requestId = this.$md5(date + id);
      this.pageWikipediaParams.loading = true;
      this.$http.post(
        "/content/flow/homePageFlow",
        {},
        {
          //TODO:修改请求参数
          pageNum: this.pageWikipediaParams.newPage + 1,
          pageSize: this.pageWikipediaParams.size,
          crmId: (this.userInfo && this.userInfo.crm_id) || "0",
          requestId: this.requestId,
          userId: getCookie("xmh_unionid") || "",
          tagId: Number(tagId) || 3,
          babyBirthDay: babyBirthDay,
          isCustomized: babyInfo && babyInfo.length ? true : false,
          sequenceId: sessionStorage.getItem("sequenceId") || "",
          // tagId: 0, //月龄id
        },
        (res) => {
          if (res.code == 200) {
            console.log(res, "911911911");
            // const { content, totalElements, size } = res.data;
            this.dataList = [...this.dataList, ...res.data];
            // page == 1，则初始化瀑布流数据，否则push数据
            if (this.pageWikipediaParams.page != 1) {
              this.$refs.waterfall.initData("push", res.data);
            } else {
              this.$refs.waterfall.initData("init", this.dataList);
            }
            this.$nextTick(() => {
              // 当接口返回数据为空时，显示加载完成
              if (res.data.length <= 0) {
                this.pageWikipediaParams.finished = true;
              } else {
                this.pageWikipediaParams.finished = false;
                this.pageWikipediaParams.page += 1;
                this.pageWikipediaParams.newPage += 1;
              }
            });
            // res.start == true
            //   ? localStorage.setItem('currentPage', 1)
            //   : localStorage.setItem(
            //       'currentPage',
            //       this.pageWikipediaParams.newPage
            //     )
            console.log(66888, localStorage.getItem("currentPage"));
            // // 神策曝光埋点
            setTimeout(() => {
              console.log("xmhh5_home_feeds_view");
              xmhziyuanwei_data_expo.observe(
                "xmh5_ziyuanwei_view",
                ".water-burial-point",
                false
              );
              Exposurer_babyList_Fn.observe(
                "NewsShown",
                ".water-fall-item",
                false
              );
              Exposurer_informationlist_Fn.observe(
                "xmhh5_home_feeds_view",
                ".information-info",
                false
              );
              Exposurer_babyFeed_pbuliu_Fn.observe(
                "xmhh5_bbsp_view",
                ".water-fall-li",
                false
              );
            }, 300);
          } else {
            this.$toast("网络异常");
            this.pageWikipediaParams.loading = false;
            this.pageWikipediaParams.error = true;
          }
        },
        (err) => {
          console.log(err, "error");
        },
        "lucky"
      );
    },
    // 根据传入的data，筛选埋点数据
    getBuiedPointObj(data, index) {
      data.moduleType == 11 &&
        sessionStorage.setItem("sequenceId", data.sequenceId);
      return {
        xmhh5_home_feeds_isoparea:
          (data.columnId == 17 && "资源位") || "非资源位",
        xmhh5_home_feeds_type:
          data.columnId == 17
            ? (data.classify == 1 && "商品") ||
              (data.classify == 4 && "链接") ||
              ""
            : "",
        xmhh5_home_feeds_url:
          (data.columnId == 17 && data.classify == 4 && data.contentUrl) || "",
        xmhh5_home_feeds_number: index + 1,
        xmhh5_home_feeds_title: data.title,
        xmhh5_home_feeds_googsname:
          data.columnId == 18 || (data.columnId == 17 && data.goodsName)
            ? data.title || data.goodsName
            : "",

        // xmhh5_bbsp_monthage
      };
    },
    setBuiedParasm(data) {
      // console.log(data, '211985')
      return {
        xmhh5_bbsp_viewstation: "首页信息流宝宝食谱",
        xmhh5_bbsp_title: data.title,
        xmhh5_bbsp_monthage: this.monthage,
        type: data,
      };
    },
    // 跳转详情
    clickHander(item, type, index) {
      setTimeout(() => {
        // 文章点击曝光
        if (item.columnId == 1) {
          this.BuiedPointClick_Fn("NewsClick", {
            xmhh5_articletitle_view_pagename: "首页瀑布流",
            xmhh5_article_title: item.title,
          });
        }
        // 宝宝食谱点击埋点
        if (item.columnId == 9) {
          BuiedPointClick_Fn("xmhh5_bbsp_click", {
            xmhh5_bbsp_title: item.title,
            xmhh5_bbsp_viewstation: "首页信息流宝宝食谱",
            xmhh5_bbsp_monthage: this.monthage,
          });
        }

        this.BuiedPointClick_Fn(
          "xmhh5_home_feeds_click",
          this.getBuiedPointObj(item, index)
        );
      }, 300);
      // 2凯琪育儿 3育儿音频 6.营养厨房 5.星妈课堂 6.哈佛课堂 7.京城名医 8奶娃百科  9.儿歌动画 10.星生活 11商品  17：资源位 13 宝宝食谱
      console.log(item, "点击的瀑布流单个");
      if (item.jumpType) {
        sensors.track("xmh5_ziyuanwei_click", {
          ...resourceNiche(item),
          xmh5_ziyuanwei_position: index + 1,
        });
        advertisJump(item, this).then((res) => {
          const doctorInfo = {
            ...res,
            contentUrl: res.jumpTargetUrl,
            contentPayUrl: res.jumpTargetUrl,
          };
          this.$emit("homeResourceClick", doctorInfo);
        });
      } else {
        switch (JSON.stringify(item.columnId)) {
          case "2":
          case "3": {
            setTimeout(() => {
              console.log(111, "audioDetail");
              this.$router.push({
                path: "/babyWikipedia/audioDetail",
                query: {
                  id: item.id,
                  type: item.columnId, // 0 凯琪 1 育儿
                  period_id: this.tagId ? this.tagId : "0",
                },
              });
            }, 300);
            break;
          }
          case "6": {
            this.jump(
              `/foodColumn/foodDetail/${item.id}?topId=${item.topId}`,
              true
            );
            break;
          }
          case "7": {
            this.jump(item.contentUrl, false);
            break;
          }
          case "8": {
            this.jump(
              "/harvard/" + item.id + "?pageSource=class&source=home",
              true
            );
            break;
          }
          case "5": {
            console.log(item.id);
            this.$emit("doctorsClick", item.id);

            break;
          }
          case "1": {
            this.jump("/baby/detail/" + item.id, true);
            break;
          }
          case "4": {
            // debugger
            setTimeout(() => {
              this.$router.push({
                name: "parentchildsongsdetail",
                query: {
                  id: item.id,
                },
              });
            }, 300);
            break;
          }
          // 10,11,17 跳转配置的链接，判断系统，ios跳转走gotomini，安卓跳转走jump
          // case "11": {
          //   let jumpUrl = 'subPackages/shopMainProcess/product/index.html?productId=' + item.moduleId + '&skuId=' + item.skuId + '&actionLinkCode=10013'
          //   this.isSystem && this.goToMini("information"+index+item.moduleId, jumpUrl, false)
          //   break;
          // }
          case "19":
          case "17":
            {
              if (
                /(http|https):\/\/([\w.]+\/?)\S*/.test(item.contentUrl) &&
                !item.goodsId
              ) {
                this.jump(item.contentUrl, false);
              } else {
                // 判断是否是小程序链接，是的话不跳转
                if (item.contentUrl.indexOf("subPackages") == -1) {
                  this.jump(item.contentUrl, true);
                }
              }
            }
            // ios系统，并且配置的链接
            // this.isSystem && this.goToMini("information"+index+item.id, item.contentUrl, false) || this.jump(item.contentUrl, false)
            // if(!item.goodsId && ){
            //   this.jump(item.contentUrl, false)
            // }
            break;
          case "9": {
            // 食谱详情
            sessionStorage.setItem("feedBack", "/home");
            this.jump("/babyFeedDetails/" + item.id, true);
            break;
          }
          default: {
            console.log("没有匹配当前columnId的类型");
          }
        }
      }
    },
    // 瀑布流样式完毕
    styleEnd() {
      this.pageWikipediaParams.loading = false;
    },
    // 未开始直播时计算时间
    returnDate: function (date) {
      date = new Date(Date.parse(date.replace(/-/g, "/")));
      var month = new Date(date).getMonth() + 1;
      var day = new Date(date).getDate();
      var weekday = new Array(7);
      weekday[0] = "星期日";
      weekday[1] = "星期一";
      weekday[2] = "星期二";
      weekday[3] = "星期三";
      weekday[4] = "星期四";
      weekday[5] = "星期五";
      weekday[6] = "星期六";
      var week = weekday[new Date(date).getDay()];
      var hours = new Date(date).getHours();
      if (hours < 10) hours = "0" + hours;
      var minute = new Date(date).getMinutes();
      if (minute < 10) minute = "0" + minute;
      console.log(month + "月" + day + "日 " + hours + ":" + minute);
      return month + "月" + day + "日 " + hours + ":" + minute;
    },
  },
};
